import { gsap } from 'gsap';

document.querySelectorAll('.js-tag-set').forEach((elem) => {
    const tagList = elem.closest('.js-tag-set-list');

    function expandTags() {
        elem.setAttribute('aria-expanded', 'true');
        tagList.classList.add('c-tag-set__list--expanded');
        gsap.to(elem.parentElement, { duration: 0.2, autoAlpha: 0, ease: 'circ.out' });
        elem.parentElement.setAttribute('aria-hidden', 'true');
    }

    elem.addEventListener('click', function(e) {
        if (elem.getAttribute('aria-expanded') === 'false') { expandTags(); }
        elem.blur();
    });
});
